export const LOKALISE_URL = "https://lokalise.attensi.com"
